<script setup="">
import { computed } from "vue";

import { useColor } from "@/composables/color";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  }
});

const color = useColor();

const hasUtmValue = computed(() => props.campaign.settings.utm_source || props.campaign.settings.utm_medium);
const linkBgColor = computed(() => color.getLightnessColor(props.campaign.settings.background_color, 0.96));

const getLink = (link) => {
  if (link.type === "link") {
    if (hasUtmValue.value) {
      return `${link}?utm_source=${props.campaign.settings.utm_source}&utm_medium=${props.campaign.settings.utm_medium}`;
    }
    return link.value;
  }

  return `tel:${link.value}`;
};
</script>

<template>
  <div class="sticky top-[calc(var(--ios-padding-top)+55px)] z-10 lg:top-[calc(var(--ios-padding-top)+50px)]">
    <div class="campaign-sub-link touch-pan-x overflow-scroll bg-[#fff] scrollbar-hide" @touchstart.stop @touchmove.stop>
      <ul class="flex items-center space-x-2 py-2 first:pl-4">
        <li v-for="link in campaign.settings.links" :key="link.name">
          <a
            :href="getLink(link)"
            :target="link.target"
            class="nav-link block whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-semibold text-zinc-800 transition hover:scale-[0.98]"
            :style="{ backgroundColor: linkBgColor }"
          >
            {{ link.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
